export function checkVideoProvider(trailerUrl?: string) {
  if (trailerUrl?.includes('vimeo')) return 'vimeo'
  return 'youtube'
}